import { ExcelIcon, ImageIcon, OtherDocumentIcon, SvgPdfIcon, WordIcon } from "../assets/images"
import { getFileType } from "./helper"

export const getFileIcon = (fileName: string) => {
  const sizeProps = { width: '1rem', height: '1rem' }
  const fileType = getFileType(fileName)
  switch (fileType) {
    case 'pdf':
      return <SvgPdfIcon {...sizeProps} />
    case 'word':
      return <WordIcon {...sizeProps} />
    case 'excel':
      return <ExcelIcon {...sizeProps} />
    case 'image':
      return <ImageIcon {...sizeProps} />
    case 'other':
      return <OtherDocumentIcon {...sizeProps} />
    default:
      return null
  }
}